import { api_configuration } from "../../common";
import client_request_decorator = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_request.alan_api;

type Builder = (
	tail: client_request_decorator.Tconditional_child_path
) => client_request_decorator.Tconditional_child_path;

class ConditionalChildPathBuilder {
	build_steps: Builder[];

	constructor(build_steps: Builder[] = []) {
		this.build_steps = build_steps;
	}

	newBuilder(build_function: Builder): ConditionalChildPathBuilder {
		return new ConditionalChildPathBuilder(this.build_steps.slice(0).concat(build_function));
	}

	build(): client_request_decorator.Tconditional_child_path {
		return this.build_steps
			.slice(0)
			.reverse()
			.reduce(
				function (tail, build_step) {
					return build_step(tail);
				},
				{ "has steps": ["no", {}] }
			);
	}
	extendPath(
		step: client_request_decorator.Tyes__has_steps__conditional_child_path["type"]
	): ConditionalChildPathBuilder {
		return this.newBuilder(function (tail: client_request_decorator.Tconditional_child_path) {
			return {
				"has steps": [
					"yes",
					{
						type: step,
						tail: tail,
					},
				],
			};
		});
	}
	group(group: string): ConditionalChildPathBuilder {
		return this.extendPath(["group", { group: group }]);
	}
	state(state_group: string, state: string): ConditionalChildPathBuilder {
		return this.extendPath([
			"state",
			{
				"state group": state_group,
				state: state,
			},
		]);
	}
}

export = ConditionalChildPathBuilder;
